import React from "react";
import styled from "styled-components";
import media from "styled-media-query";

// Styles
import { getFontWeight } from "../../../styles/font-weight";
import { colors } from "../../../styles/colors";

export const ProductPicture = (props) => {
  const picture = require(`../../../assets/images/${props.pictureName}.png`);

  return (
    <StyledDivProductPicture picturePath={picture}>
      <StyledDivTitle>
        <StyledLink2Product href={props.url}>{props.title}</StyledLink2Product>
      </StyledDivTitle>
    </StyledDivProductPicture>
  );
};

const StyledDivProductPicture = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  background: url(${(props) => {
    return props.picturePath;
  }});
  background-size: cover;
  ${media.lessThan("small")`
    width: 100%;
    height: 250px;
  `};

  ${media.greaterThan("medium")`
    height: 500px;
    width: 50%;
  `};
`;
const StyledDivTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${colors.gray__low_opacity};
  ${media.lessThan("small")`
    height: 55px;
  `};

  ${media.greaterThan("medium")`
    height: 100px;
  `};
`;
const StyledLink2Product = styled.a`
  display: block;
  text-decoration: none;
  color: ${colors.white};
  ${getFontWeight("Medium")};

  ${media.lessThan("small")`
    padding: 0 16px;
  `};

  ${media.greaterThan("medium")`
    font-size: 28px;
    padding: 0 32px;
  `};
`;
